<template>
  <div id="contenedor-listado-desktop">
    <v-data-table
      :headers="headers"
      :items="listadoAdjudicacionesDirectas"
      :loading="cargando"
      :items-per-page="-1"
      hide-default-footer>
      <template v-slot:[`item.numeroContrato`]="{ item }">
        <v-btn text small color="primary" class="px-0" @click="abrirFicha(item)">
          {{ item.numeroContrato }}
        </v-btn>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :adjudicacionDirecta="item"></opciones>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ new Date(item.fecha).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.importe`]="{ item }">
        {{item.importe | currency}}
      </template>
      <template v-slot:[`item.iva`]="{ item }">
        {{item.iva | currency}}
      </template>
      <template v-slot:[`item.total`]="{ item }">
        {{item.total | currency}}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      <template v-slot:[`item.meta`]="{ item }">
        <cortar-texto
        :texto="item.meta"></cortar-texto>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoAdjudicacionesDesktop',
  props: {
    listadoAdjudicacionesDirectas: {
      type: Array,
      required: true,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Opciones,
    FechaHumano,
    CortarTexto,
  },
  data() {
    return {
      headers: [
        {
          text: 'Número de Contrato',
          align: 'start',
          value: 'numeroContrato',
          width: '150',
          sortable: false,
        },
        { text: 'Contratista', value: 'contratista.nombreRazonSocial', sortable: false },
        { text: 'Objeto', value: 'meta', sortable: false },
        { text: 'Número de Dictamen', value: 'numeroDictamen', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Importe', value: 'importe', sortable: false },
        { text: 'IVA', value: 'iva', sortable: false },
        { text: 'Total', value: 'total', sortable: false },
        { text: 'F. Registro', value: 'createdAt', width: '120' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    abrirFicha(adjudicacionDirecta) {
      this.$router.push({
        name: 'adjudicacion',
        params: {
          idAdjudicacion: adjudicacionDirecta.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">

</style>
